import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

// Logical area: StringHelperFunctions General Strings
class Id {
  private constructor() {}
  public static readonly prefix = 'UI.webmodule-common.other.ui.StringHelperFunctions.';

  public static readonly yes = `${Id.prefix}yes`;
  public static readonly no = `${Id.prefix}no`;
}

export class LangStringHelperFunctions {
  private constructor() {}

  public static yes(): string {
    return interpolate(Id.yes);
  }
  public static no(): string {
    return interpolate(Id.no);
  }
}

export class StringHelperFunctionsModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    // General
    register.add(Id.yes, 'Yes', 'Yes label');
    register.add(Id.no, 'No', 'No label');
  }
}
